import React from "react";
import {
  Button,
  TextField,
  Box,
  Grid2 as Grid,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";
import { Link, useNavigate } from "react-router-dom";
// import { showErrorToast, showSuccessToast } from "../../common/util/util";
import { ToastContainer } from "react-toastify";
import { Editor } from "@tinymce/tinymce-react";
import { addJob } from "./Jobs.service";

// Validation schema for the form
const validationSchema = yup.object({
  firstname: yup.string().required("First Name is required"),
  lastname: yup.string().required("Last Name is required"),
  jobtype: yup.string().required("Job Type is required"),
  email: yup
    .string()
    .email("Invalid email format")
    .required("Email is required"),
  number: yup.string().required("Mobile Number is required"),
  description: yup.string().required("Description is required"),
  ticketAccount: yup.string().required("Ticket Account is required"),
});

const AddJob = () => {
  const initialValues = {
    firstname: "",
    lastname: "",
    jobtype: "",
    email: "",
    number: "",
    description: "",
    ticketAccount: "",
  };

  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("firstname", values.firstname);
      formData.append("lastname", values.lastname);
      formData.append("jobtype", values.jobtype);
      formData.append("email", values.email);
      formData.append("number", values.number);
      formData.append("description", values.description);
      formData.append("ticketAccount", values.ticketAccount);

      // Call the API to add the job
      addJob(formData)
        .then((res: any) => {
          // showSuccessToast(res.message);
          navigate("/jobs");
        })
        .catch((err) => {
          console.error(err.message);
        });
    },
  });

  return (
    <Box paddingY={4}>
      <h3>Add Job</h3>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}>
            <label htmlFor="name" className="form-label">
              First Name
            </label>
            <TextField
              fullWidth
              name="firstname"
              placeholder="First Name"
              value={formik.values.firstname}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.firstname && Boolean(formik.errors.firstname)
              }
              helperText={formik.touched.firstname && formik.errors.firstname}
            />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <label htmlFor="lastname" className="form-label">
              Last Name
            </label>
            <TextField
              fullWidth
              name="lastname"
              placeholder="Last Name"
              value={formik.values.lastname}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.lastname && Boolean(formik.errors.lastname)}
              helperText={formik.touched.lastname && formik.errors.lastname}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <label htmlFor="jobtype" className="form-label">
              Job Type
            </label>
            <TextField
              fullWidth
              name="jobtype"
              placeholder="Last Name"
              value={formik.values.jobtype}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.jobtype && Boolean(formik.errors.jobtype)}
              helperText={formik.touched.jobtype && formik.errors.jobtype}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <label htmlFor="email" className="form-label">
              Email
            </label>
            <TextField
              fullWidth
              name="email"
              placeholder="Email"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <label htmlFor="number" className="form-label">
              Mobile Number
            </label>
            <TextField
              fullWidth
              name="number"
              placeholder="Mobile Number"
              value={formik.values.number}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.number && Boolean(formik.errors.number)}
              helperText={formik.touched.number && formik.errors.number}
            />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <label htmlFor="ticketAccount" className="form-label">
              Ticket Account
            </label>
            <TextField
              fullWidth
              name="ticketAccount"
              placeholder="Ticket ACcount"
              value={formik.values.ticketAccount}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.ticketAccount &&
                Boolean(formik.errors.ticketAccount)
              }
              helperText={
                formik.touched.ticketAccount && formik.errors.ticketAccount
              }
            />
          </Grid>
          <Grid size={{ xs: 12, md: 12 }}>
            <label htmlFor="description" className="form-label">
              Description
            </label>
            <Editor
              apiKey="3pjt2aff819falfnto6263vp07u7yulkgdebfot8bdy37rv1"
              value={formik.values.description}
              init={{
                plugins: [
                  "anchor",
                  "autolink",
                  "charmap",
                  "codesample",
                  "emoticons",
                  "image",
                  "link",
                  "lists",
                  "media",
                  "searchreplace",
                  "table",
                  "visualblocks",
                  "wordcount",
                  "checklist",
                  "mediaembed",
                  "casechange",
                  "export",
                  "formatpainter",
                  "pageembed",
                  "a11ychecker",
                  "tinymcespellchecker",
                  "permanentpen",
                  "powerpaste",
                  "advtable",
                  "advcode",
                  "editimage",
                  "advtemplate",
                  "ai",
                  "mentions",
                  "tableofcontents",
                  "footnotes",
                  "mergetags",
                  "autocorrect",
                  "typography",
                  "inlinecss",
                  "markdown",
                  "importword",
                  "exportword",
                  "exportpdf",
                ],
                toolbar:
                  "undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat",
                // tinycomments_mode: 'embedded',
                // tinycomments_author: 'Author name',
                // mergetags_list: [
                //     { value: 'First.Name', title: 'First Name' },
                //     { value: 'Email', title: 'Email' },
                // ],
                // ai_request: (request: any, respondWith: any) => respondWith.string(() => Promise.reject('See docs to implement AI Assistant')),
                exportpdf_converter_options: {
                  format: "Letter",
                  margin_top: "1in",
                  margin_right: "1in",
                  margin_bottom: "1in",
                  margin_left: "1in",
                },
                exportword_converter_options: { document: { size: "Letter" } },
                importword_converter_options: {
                  formatting: {
                    styles: "inline",
                    resets: "inline",
                    defaults: "inline",
                  },
                },
              }}
              onEditorChange={(newValue) =>
                formik.setFieldValue("description", newValue)
              }
            />
            {formik.touched.description &&
              Boolean(formik.errors.description) && (
                <Typography color="error">
                  {formik.errors.description}
                </Typography>
              )}
          </Grid>
          <Grid
            size={{ xs: 12, md: 12 }}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button component={Link} to="/jobs" color="secondary">
              Cancel
            </Button>
            <Button type="submit" color="primary" variant="contained">
              Add Job
            </Button>
          </Grid>
        </Grid>
      </form>
      <ToastContainer position="top-right" autoClose={3000} />
    </Box>
  );
};

export default AddJob;
